import useSWR from "swr";
import React, {useMemo} from "react";
import {getFetcher} from "../api/fetchers";
import {useNotification} from "../hooks/useNotification";
import {CategoryShort} from "../../schemas/category/categoriesSchema";

interface CategoriesContextProps {
    children: React.ReactNode;
}

interface CategoriesContextValue {
    categories?: CategoryShort[],
    isLoading: boolean,
    error?: any,
}

const CategoriesContext = React.createContext<CategoriesContextValue | undefined>(undefined);

export const CategoriesProvider: React.FC<CategoriesContextProps> = ({children}) => {
    const {showNotification} = useNotification();
    const {data, isLoading, error} = useSWR<CategoryShort[]>(`/categories`, getFetcher, {keepPreviousData: true});

    if (error) {
        showNotification("Data kategorií se nepodařilo načíst", "error");
    }

    const contextValue = useMemo(() => ({
        categories: data,
        isLoading,
        error,
    }), [data, error, isLoading]);

    return (
        <CategoriesContext.Provider value={contextValue}>
            {children}
        </CategoriesContext.Provider>
    );
};

export const useCategories = () => {
    const context = React.useContext(CategoriesContext);
    if (!context) throw new Error("useCategories must be used within a CategoriesProvider");
    return context;
};
